import Skeleton from '@mui/material/Skeleton';
import { Card } from '@ps/isp-web-component-library';
import React from 'react';

import styles from './SkeletonOpportunity.scss';

export default () => (
  <Card isPadded className={styles.opportunity} data-testid="skeleton-opportunity">
    <div>
      <Skeleton variant="rectangular" height="24px" width="24px" animation="pulse" />
      <Skeleton variant="rectangular" height="24px" width="120px" animation="pulse" />
      <Skeleton variant="rectangular" height="24px" width="63px" animation="pulse" />
    </div>
    <Skeleton variant="rectangular" height="23px" width="229px" animation="pulse" />
    <Skeleton variant="rectangular" height="24px" width="105px" animation="pulse" />
    <Skeleton variant="rectangular" height="24px" width="105px" animation="pulse" />
  </Card>
);
